import {isEmpty} from 'lodash';
import {useRenderSgfMutation} from '@api';
import {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';

export const SgfRenderer = ({
    sgf,
    ...props
}: {
    sgf: string;
    [key: string]: any;
}) => {
    const {t} = useTranslation();
    const [rendered, setRendered] = useState('');
    const [renderSgf] = useRenderSgfMutation();

    useEffect(() => {
        if (isEmpty(sgf)) return;
        async function fetchData() {
            try {
                const response = await renderSgf({sgf}).unwrap();
                const svgBase64 = `data:image/svg+xml;base64,${btoa(response)}`;
                setRendered(svgBase64);
            } catch (error) {
                console.log(error);
                console.error('render failed');
            }
        }
        fetchData();
    }, [sgf, renderSgf]);

    return (
        <div {...props}>
            <img className="w-100" alt={t('common.sgf_preview')} src={rendered} />
        </div>
    );
};
